/* eslint no-underscore-dangle: 0 */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { setErrorNotification } from '../../../../redux/slices/NotificationSlice';
import ModalBox from '../../../../shared/component/ModalBox';
import TemplateContentUpload from '../TemplateContentUpload';
import HtmlHeader from '../HtmlHeader';
import utils from '../templateFunctions';
import FileFormat from '../FileFormat';
import { createOrUpdateTemplate } from '../../../../redux/slices/TemplateSlice';
import PopupBox from '../ContentUploadConfirmation';

function HtmlTemplateTwentyOne({ templateData }) {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [openContentUploadConfirmation, setOpenContentUploadConfirmation] = useState(false);
  const [base64, setBase64] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [disable, setDisable] = useState(true);
  const [modalView, setModalView] = useState({ content: '', title: '' });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const htmlRef = useRef(null);
  const convertBase64Ref = useRef(null);
  const convertHtmlRef = useRef(null);

  const cssStyles = `
    body {
      margin: 0;
      padding: 0;
    }
    .employee-card {
      position: relative;
      font-family: "Montserrat", sans-serif;
      box-sizing: border-box;
      overflow: hidden;
      height: 93.6vh;
    }
    @media (max-width: 768px) {
      .employee-card {
        height: auto;
        min-height: 100vh;
      }
    }
    .employee-card__content {
      max-width: max-content;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    @media (max-width: 768px) {
      .employee-card__content {
        max-width: 100%;
        width: 100%;
      }
    }
    .employee-card .main-container {
      height: 100%;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    @media (max-width: 1024px) {
      .employee-card .main-container {
        padding: 25px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .main-container {
        padding: 20px 15px;
        justify-content: flex-start;
        min-height: 100vh;
      }
    }
    @media (max-width: 480px) {
      .employee-card .main-container {
        padding: 15px 10px;
      }
    }
    .employee-card .left-top-image--top {
      position: absolute;
      width: 61px;
      height: 100px;
      top: 60px;
    }
    @media (max-width: 1024px) {
      .employee-card .left-top-image--top {
        width: 50px;
        height: 82px;
        top: 40px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .left-top-image--top {
        width: 40px;
        height: 65px;
        top: 30px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .left-top-image--top {
        width: 30px;
        height: 50px;
        top: 20px;
      }
    }
    .employee-card .left-top-image--bottom {
      position: absolute;
      top: 130px;
      width: 80px;
      height: 205px;
      inset-inline-start: 0;
    }
    @media (max-width: 1024px) {
      .employee-card .left-top-image--bottom {
        width: 65px;
        height: 165px;
        top: 100px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .left-top-image--bottom {
        width: 50px;
        height: 130px;
        top: 80px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .left-top-image--bottom {
        width: 40px;
        height: 100px;
        top: 60px;
      }
    }
    .employee-card .left-top-image--start-yellow {
      position: absolute;
      top: 70px;
      inset-inline-start: 90px;
      width: 16px;
      height: 19px;
    }
    @media (max-width: 1024px) {
      .employee-card .left-top-image--start-yellow {
        top: 50px;
        inset-inline-start: 70px;
        width: 14px;
        height: 16px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .left-top-image--start-yellow {
        top: 40px;
        inset-inline-start: 50px;
        width: 12px;
        height: 14px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .left-top-image--start-yellow {
        top: 30px;
        inset-inline-start: 40px;
        width: 10px;
        height: 12px;
      }
    }
    .employee-card__logo {
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 10px;
      width: 100%;
    }
    @media (max-width: 768px) {
      .employee-card__logo {
        justify-content: center;
        margin-bottom: 20px;
      }
    }
    .employee-card__logo img {
      width: 25px;
    }
    @media (max-width: 768px) {
      .employee-card__logo img {
        width: 20px;
      }
    }
    .employee-card .detils-employee {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
      width: 100%;
      max-width: 500px;
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee {
        gap: 15px;
        max-width: 100%;
      }
    }
    .employee-card .detils-employee--start-white1 {
      position: absolute;
      top: 35%;
      inset-inline-end: -38px;
      width: 16px;
      height: 19px;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee--start-white1 {
        inset-inline-end: -20px;
        width: 14px;
        height: 16px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee--start-white1 {
        display: none;
      }
    }
    .employee-card .detils-employee--circle-yellow {
      position: absolute;
      top: 50%;
      inset-inline-start: -30%;
      width: 10px;
      height: 10px;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee--circle-yellow {
        inset-inline-start: -20%;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee--circle-yellow {
        display: none;
      }
    }
    .employee-card .detils-employee__title {
      text-align: center;
      color: #FBE106;
      margin: 0;
      width: 100%;
    }
    .employee-card .detils-employee__title .highlight-first {
      font-size: 52px;
      font-weight: 600;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee__title .highlight-first {
        font-size: 42px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee__title .highlight-first {
        font-size: 32px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .detils-employee__title .highlight-first {
        font-size: 28px;
      }
    }
    .employee-card .detils-employee__title .highlight-middle {
      font-size: 32px;
      font-weight: 500;
      display: block;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee__title .highlight-middle {
        font-size: 26px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee__title .highlight-middle {
        font-size: 20px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .detils-employee__title .highlight-middle {
        font-size: 18px;
      }
    }
    .employee-card .detils-employee__title .highlight-last {
      font-size: 70px;
      font-weight: 700;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee__title .highlight-last {
        font-size: 56px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee__title .highlight-last {
        font-size: 42px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .detils-employee__title .highlight-last {
        font-size: 36px;
      }
    }
    .employee-card .detils-employee__image {
      border: 4px solid #FBE106;
      border-radius: 50%;
      width: 300px;
      height: 300px;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee__image {
        width: 250px;
        height: 250px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee__image {
        width: 200px;
        height: 200px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .detils-employee__image {
        width: 150px;
        height: 150px;
        border-width: 3px;
      }
    }
    .employee-card .detils-employee__image img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      padding: 15px;
    }
    @media (max-width: 480px) {
      .employee-card .detils-employee__image img {
        padding: 10px;
      }
    }
    .employee-card .detils-employee__name {
      font-size: 24px;
      font-weight: 600;
      color: #FBE106;
      margin: 0px;
      text-align: center;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee__name {
        font-size: 20px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee__name {
        font-size: 18px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .detils-employee__name {
        font-size: 16px;
      }
    }
    .employee-card .detils-employee__role {
      font-weight: 500;
      color: #FFF;
      margin: 0px;
      text-align: center;
      font-size: 18px;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee__role {
        font-size: 16px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee__role {
        font-size: 14px;
      }
    }
    @media (max-width: 480px) {
      .employee-card .detils-employee__role {
        font-size: 13px;
      }
    }
    .employee-card .detils-employee--circle-white {
      position: absolute;
      bottom: 22%;
      inset-inline-end: -20%;
      width: 15px;
      height: 15px;
    }
    @media (max-width: 1024px) {
      .employee-card .detils-employee--circle-white {
        inset-inline-end: -15%;
      }
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee--circle-white {
        display: none;
      }
    }
    .employee-card .detils-employee--start-white2 {
      position: absolute;
      bottom: 25%;
      inset-inline-start: -50%;
      width: 16px;
      height: 19px;
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee--start-white2 {
        display: none;
      }
    }
    .employee-card .detils-employee--start-yellow1 {
      position: absolute;
      bottom: 13%;
      inset-inline-start: -10%;
      width: 16px;
      height: 19px;
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee--start-yellow1 {
        display: none;
      }
    }
    .employee-card .detils-employee--start-yellow2 {
      position: absolute;
      bottom: -10px;
      inset-inline-end: -10%;
      width: 16px;
      height: 19px;
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee--start-yellow2 {
        display: none;
      }
    }
    .employee-card .detils-employee--start-yellow3 {
      position: absolute;
      bottom: 5%;
      inset-inline-end: -60%;
      width: 16px;
      height: 19px;
    }
    @media (max-width: 768px) {
      .employee-card .detils-employee--start-yellow3 {
        display: none;
      }
    }
    .employee-card .right-bottom-image--top {
      position: absolute;
      width: 61px;
      height: 100px;
      bottom: 40%;
      inset-inline-end: 0;
      transform: rotate(180deg);
    }
    @media (max-width: 1024px) {
      .employee-card .right-bottom-image--top {
        width: 50px;
        height: 82px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .right-bottom-image--top {
        width: 40px;
        height: 65px;
        bottom: 50%;
      }
    }
    @media (max-width: 480px) {
      .employee-card .right-bottom-image--top {
        width: 30px;
        height: 50px;
      }
    }
    .employee-card .right-bottom-image--bottom {
      position: absolute;
      bottom: 15%;
      width: 80px;
      height: 205px;
      inset-inline-end: 0;
      transform: rotate(180deg);
    }
    @media (max-width: 1024px) {
      .employee-card .right-bottom-image--bottom {
        width: 65px;
        height: 165px;
      }
    }
    @media (max-width: 768px) {
      .employee-card .right-bottom-image--bottom {
        width: 50px;
        height: 130px;
        bottom: 20%;
      }
    }
    @media (max-width: 480px) {
      .employee-card .right-bottom-image--bottom {
        width: 40px;
        height: 100px;
      }
    }

    @media (max-height: 600px) and (orientation: landscape) {
      .employee-card {
        height: auto;
        min-height: 100vh;
      }
      .employee-card .main-container {
        padding: 15px;
        flex-direction: row;
        gap: 20px;
      }
      .employee-card .detils-employee__image {
        width: 120px;
        height: 120px;
      }
      .employee-card .detils-employee__title .highlight-first {
        font-size: 24px;
      }
      .employee-card .detils-employee__title .highlight-middle {
        font-size: 18px;
      }
      .employee-card .detils-employee__title .highlight-last {
        font-size: 28px;
      }
      .employee-card .detils-employee__name {
        font-size: 14px;
      }
      .employee-card .detils-employee__role {
        font-size: 12px;
      }
      .employee-card .left-top-image,
    .employee-card .right-bottom-image,
    .employee-card .detils-employee--start-white1,
    .employee-card .detils-employee--circle-yellow,
    .employee-card .detils-employee--circle-white,
    .employee-card .detils-employee--start-white2,
    .employee-card .detils-employee--start-yellow1,
    .employee-card .detils-employee--start-yellow2,
    .employee-card .detils-employee--start-yellow3 {
        display: none;
      }
    }
    @media (min-width: 1440px) {
      .employee-card .main-container {
        padding: 40px;
      }
      .employee-card .detils-employee__image {
        width: 350px;
        height: 350px;
      }
      .employee-card .detils-employee__title .highlight-first {
        font-size: 60px;
      }
      .employee-card .detils-employee__title .highlight-middle {
        font-size: 36px;
      }
      .employee-card .detils-employee__title .highlight-last {
        font-size: 80px;
      }
      .employee-card .detils-employee__name {
        font-size: 28px;
      }
      .employee-card .detils-employee__role {
        font-size: 20px;
      }
    }
    @media (min-width: 1920px) {
      .employee-card .main-container {
        padding: 50px;
        max-width: 1920px;
        margin: 0 auto;
      }
    }
    @media print {
      .employee-card {
        height: auto;
        min-height: 100vh;
      }
      .employee-card .left-top-image,
    .employee-card .right-bottom-image,
    .employee-card .detils-employee--start-white1,
    .employee-card .detils-employee--circle-yellow,
    .employee-card .detils-employee--circle-white,
    .employee-card .detils-employee--start-white2,
    .employee-card .detils-employee--start-yellow1,
    .employee-card .detils-employee--start-yellow2,
    .employee-card .detils-employee--start-yellow3 {
        display: none;
      }
    }
  `;

  const convertImage = async (url) => {
    await utils.convertSignedUrl(url)
      .then((response) => {
        setDisable(false);
        dispatch(createOrUpdateTemplate(response));
      })
      .catch((error) => {
        setDisable(false);
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  convertBase64Ref.current = async () => {
    toPng(htmlRef?.current, { cacheBust: true })
      .then((dataUrl) => {
        setBase64(dataUrl);
        convertImage(dataUrl);
      })
      .catch((error) => {
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  convertHtmlRef.current = () => {
    if (htmlRef.current) {
      const content = htmlRef.current.outerHTML;
      const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
      setHtmlContent(fullHtml); // Set the HTML content as a string
    }
  };

  useEffect(() => {
    utils?.initializer(templateData).then((res) => (setData(res)));
    utils?.reload();
  }, [templateData]);

  /* useEffect runs convertBase64 after data is updated */
  useEffect(() => {
    if (data?.length > 0 && data?.[0]?.template_contents?.items?.length > 0) {
      setTimeout(() => {
        convertBase64Ref.current?.();
      }, 1500);
      convertHtmlRef.current?.();
    }
  }, [data]);

  const handleFileType = (fileType) => {
    setModalView({
      title: 'content',
      content: <TemplateContentUpload
        base64={base64}
        setNotification={setNotification}
        fileType={fileType}
        htmlContent={htmlContent}
      />,
    });
  };

  const onClickContentUpload = () => {
    setNotification(true);
    setModalView({
      title: t('fileFormat'),
      content: <FileFormat
        setNotification={setNotification}
        handleFileType={handleFileType}
        setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
        data={data}
      />,
    });
  };

  const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details;
  const backgroundColor = data?.[0]?.styles?.background;
  const backgroundImage = Array.isArray(data?.[0]?.template_backgroundImage_url)
    ? data?.[0]?.template_backgroundImage_url
    : [];

  return (
    <div>
      <HtmlHeader
        htmlData={data}
        disable={disable}
        click={onClickContentUpload}
      />

      <ModalBox
        status={notification}
        closeModal={setNotification}
        modalView={modalView}
      />

      <ModalBox
        status={openContentUploadConfirmation}
        closeModal={setOpenContentUploadConfirmation}
        modalView={{
          title: 'Confirmation',
          content: <PopupBox
            setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
            setNotification={setNotification}
          />,
        }}
      />

      <div className="header-height" />

      <div ref={htmlRef} className="employee-card">
        <div className="left-top-image">
          <img className="left-top-image--top" src={backgroundImage[2]} alt="Left Top" />
          <img className="left-top-image--bottom" src={backgroundImage[3]} alt="Left Top" />
          <img className="left-top-image--start-yellow" src={backgroundImage[1]} alt="Left Top" />
        </div>

        <div style={{ backgroundColor: `${backgroundColor}` }} className="main-container">
          <div className="employee-card__logo">
            <img src={backgroundImage[5]} alt="Logo" />
            <p>{contentDetails?.[0]?.company_name}</p>
          </div>

          <div className="employee-card__content">

            <div className="detils-employee">
              <img className="detils-employee--circle-yellow" src={backgroundImage[4]} alt="Left Top" />
              <img className="detils-employee--start-white1" src={backgroundImage[1]} alt="Left Top" />

              <h2 className="detils-employee__title">
                {(() => {
                  const words = contentDetails?.[0]?.item_name?.split(' ') || [];

                  if (words.length < 2) return null;

                  const firstWord = words[0];
                  const middleWords = words.slice(1, words.length - 1).join(' ');
                  const lastWord = words[words.length - 1];

                  return (
                    <>
                      <span className="highlight-first">{firstWord.toUpperCase()}</span>{' '}
                      <span className="highlight-middle">{middleWords.toUpperCase()}</span>{' '}
                      <span className="highlight-last">{lastWord.toUpperCase()}</span>
                    </>
                  );
                })()}
              </h2>

              <div className="detils-employee__image">
                <img src={contentDetails?.[0]?.image} alt="Employee Photoo" />
              </div>

              <h4 className="detils-employee__name">{contentDetails?.[0]?.name.toUpperCase()}</h4>
              <p className="detils-employee__role">{contentDetails?.[0]?.description}</p>

              <img className="detils-employee--circle-white" src={backgroundImage[6]} alt="Left Top" />
              <img className="detils-employee--start-white2" src={backgroundImage[1]} alt="Left Top" />
              <img className="detils-employee--start-yellow1" src={backgroundImage[1]} alt="Left Top" />
              <img className="detils-employee--start-yellow2" src={backgroundImage[1]} alt="Left Top" />
              <img className="detils-employee--start-yellow3" src={backgroundImage[1]} alt="Left Top" />
            </div>
          </div>

        </div>

        <div className="right-bottom-image">
          <img className="right-bottom-image--top" src={backgroundImage[2]} alt="right bottom" />
          <img className="right-bottom-image--bottom" src={backgroundImage[3]} alt="right bottom" />
        </div>
      </div>
    </div>
  );
}

HtmlTemplateTwentyOne.propTypes = {
  templateData:
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      template_title: PropTypes.string.isRequired,
    }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateTwentyOne;
